import { Body, Title4 } from 'components/Typography';
import React from 'react';
import { twMerge } from 'tailwind-merge';

interface UserBalanceItemProps {
  className?: string;
  icon: React.ReactNode;
  label: string;
  value: React.ReactNode | string;
}
export const UserBalanceItem = (props: UserBalanceItemProps) => {
  const { className, icon, label, value } = props;
  return (
    <div className={twMerge('flex flex-row gap-1', className)}>
      <div className='py-[3px]'>{icon}</div>
      <div className='flex flex-col'>
        <Body className='text-[0.75rem] text-[#D9D9D9] lg:text-[0.875rem]'>
          {label}
        </Body>
        <Title4 className='text-white'>{value}</Title4>
      </div>
    </div>
  );
};
